import type React from 'react'

type Mask = Array<string | RegExp>

export const phoneInputMask: Mask = ['+', '7', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

export const codeInputMask: Mask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]

export const dateMask: Mask = [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]

/** Puts the caret on the first empty mask position when a masked input gets focus */
export const focusMaskStart = (e: React.FocusEvent<HTMLInputElement>) => {
  const target = e.target
  setTimeout(() => {
    const startIndex = target.value.indexOf('_')
    if (startIndex !== -1) {
      target.setSelectionRange(startIndex, startIndex)
    }
  }, 0)
}
